import { DateTime } from 'luxon';

/** ISO → «12.10.2026»; нет даты — «—» */
export const formatDate = (iso: string | null): string =>
  iso ? DateTime.fromISO(iso).toFormat('dd.MM.yyyy') : '—';

/** ISO → «12.10.2026 14:30» */
export const formatDateTime = (iso: string): string =>
  DateTime.fromISO(iso).toFormat('dd.MM.yyyy HH:mm');
